import RequestFilter from "./components/RequestFilter";
import RequestList from "./components/RequestList";
import "./styles.scss";
import useRequest from "./hooks/useRequest";
import WalletLayout from "../components/WalletLayout";
import { initialPath } from "~misc/paths";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useReenvioSolicitacao } from "../hooks/useWallet";
import { Spinner } from "@chakra-ui/react";
import { useConfigureFooter } from "~hooks/useHelpers";

const Requests = () => {
  useConfigureFooter();

  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(6);

  const { cleanFilters, setFilters, filters, list, loading, total, setLoading } =
    useRequest({ take: take, skip: skip });

  useEffect(() => {
    setSkip(0);
  }, [filters]);

  const [idSolicitacao, setIdSolicitacao] = useState(0);
  const [enableReenviarSolicitacao, setEnableReenviarSolicitacao] =
    useState(false);
  const navigate = useNavigate();
  const reenvioSolicitacao = useReenvioSolicitacao(
    idSolicitacao,
    enableReenviarSolicitacao
  );

  function ReenviarSolicitacao(data) {
    setIdSolicitacao(data.id);
  }

  useEffect(() => {
    if (idSolicitacao > 0) {
      setEnableReenviarSolicitacao(true);
    }
  }, [idSolicitacao]);

  function NovaSolicitacao(data) {
    const tipo = data.tipoSolicitacao;
    if (tipo === 1 || tipo === 3)
      navigate(`${initialPath}/carteira/recebedor/${data.clienteId}`);
    else if (tipo === 2 || tipo === 4)
      navigate(`${initialPath}/carteira/emissor/${data.clienteId}`);
    else if (tipo === 5)
      navigate(`${initialPath}/carteira/credito/${data.clienteId}`);
    else if (tipo === 6)
      navigate(`${initialPath}/carteira/prospect/${data.clienteId}`);
  }
  return (
    <WalletLayout>
      <div className="flex space-x-4 container">
        <div className="w-full">
          <RequestFilter
            cleanFilters={cleanFilters}
            setFilters={setFilters}
            filters={filters}
            totalList={(list || []).length}
            total={total}
            loading={loading}
            setLoading={setLoading}
          />

          {loading ? (
            <div className="container flex items-center justify-center pt-10">
              <Spinner size={"xl"} thickness="4px" />
            </div>
          ) : (
            <RequestList
              ReenviarSolicitacao={ReenviarSolicitacao}
              NovaSolicitacao={NovaSolicitacao}
              list={list}
              filters={filters}
              total={total}
              skip={skip}
              take={take}
              setSkip={setSkip}
            />
          )}
        </div>
      </div>
    </WalletLayout>
  );
};

export default Requests;
